import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { handleError } from './common';
import { initVerificationAction } from './verification';

/*
 Mobile Actions
 */
export function initMobileAction(data) {
	return {
		type: 'INIT_MOBILE',
		data: data
	}
}

export function applyMobileAction(data) {
	return {
		type: 'APPLY_MOBILE',
		data: data
	}
}

export function verifyMobileAction(data) {
	return {
		type: 'VERIFY_MOBILE',
		data: data
	}
}

function saveMobileAction(data) {
	return {
		type: 'SAVE_MOBILE',
		data: data
	}
}

/*
 Async functions
 */
export function initMobile() {
	return dispatch => {
		fetch('/api/account/mobile/init', {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitMobile(dispatch, data))
	}
}

export function applyMobile(full_mobile_no) {
	return dispatch => {
		fetch('/api/account/mobile/apply', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				mobile_no: full_mobile_no
			})
		})
			.then(response => response.json())
			.then(data => handleApplyMobile(dispatch, data))
	}
}

export function verifyMobile(code) {
	return (dispatch, getState) => {
		const state = getState();
		const { gateway } = state.verification;
		fetch('/api/account/mobile/verify', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				code: code,
				gateway: gateway,
			})
		})
			.then(response => response.json())
			.then(data => handleVerifyMobile(dispatch, data))
	}
}

export function saveMobile(encryptedPassword) {
	return dispatch => {
		fetch('/api/account/mobile/save', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				password: encryptedPassword
			})
		})
			.then(response => response.json())
			.then(data => handleSaveMobile(dispatch, data))
	}
}

/*
 Handle functions
 */
function handleInitMobile(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/mobile/2-step-verification');
			break;
		case ACTION_TYPE.APPLY_MOBILE:
			dispatch(initMobileAction(data));
			browserHistory.push('/security/mobile/apply');
			break;
		default:
			break;
	}
}

function handleApplyMobile(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(applyMobileAction(data));
	if (data.status == 0 && data.next_action.action_type === ACTION_TYPE.VERIFY_MOBILE) {
	    dispatch(initVerificationAction(data));
		browserHistory.push('/security/mobile/verify');
	}
}

function handleVerifyMobile(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(verifyMobileAction(data));
	if (data.status == 0 && data.next_action.action_type === ACTION_TYPE.SAVE_MOBILE) {
		browserHistory.push('/security/mobile/save');
	}
}

function handleSaveMobile(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	dispatch(saveMobileAction(data));
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.DONE) {
		browserHistory.push('/security/mobile/done');
	}
}



// WEBPACK FOOTER //
// ./app/actions/mobile.js